var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineCardReceive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EB0BE687-CC6E-41CF-8C84-2D3B5EC659AB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Money",
    transform: "translate(-556.000000, -508.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "card-receive",
    transform: "translate(556.000000, 508.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,9.25 C1.59,9.25 1.25,8.91 1.25,8.5 C1.25,8.09 1.59,7.75 2,7.75 L14.5,7.75 C14.91,7.75 15.25,8.09 15.25,8.5 C15.25,8.91 14.91,9.25 14.5,9.25 L2,9.25 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,17.25 C5.59,17.25 5.25,16.91 5.25,16.5 C5.25,16.09 5.59,15.75 6,15.75 L8,15.75 C8.41,15.75 8.75,16.09 8.75,16.5 C8.75,16.91 8.41,17.25 8,17.25 L6,17.25 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5,17.25 C10.09,17.25 9.75,16.91 9.75,16.5 C9.75,16.09 10.09,15.75 10.5,15.75 L14.5,15.75 C14.91,15.75 15.25,16.09 15.25,16.5 C15.25,16.91 14.91,17.25 14.5,17.25 L10.5,17.25 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.44000006,21.25 C2.46000004,21.25 1.25,20.0500007 1.25,16.1100006 L1.25,7.88999987 C1.25,3.94999981 2.46000004,2.75 6.44000006,2.75 L14.5,2.75 C14.91,2.75 15.25,3.09 15.25,3.5 C15.25,3.91 14.91,4.25 14.5,4.25 L6.44000006,4.25 C3.29999995,4.25 2.75,4.78999996 2.75,7.88999987 L2.75,16.1000004 C2.75,19.2000003 3.29999995,19.7399998 6.44000006,19.7399998 L17.5499992,19.7399998 C20.6899993,19.7399998 21.2399998,19.2000003 21.2399998,16.1000004 L21.2399998,14.0200005 C21.2399998,13.6100005 21.5799998,13.2700005 21.9899998,13.2700005 C22.3999998,13.2700005 22.7400608,13.6100005 22.7400608,14.0200005 L22.7400608,16.1000004 C22.75,20.0500004 21.5399995,21.25 17.5599995,21.25 L6.44000006,21.25 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7099991,10.1899996 C19.4299991,10.0699996 19.25,9.80000001 19.25,9.5 L19.25,3.5 C19.25,3.09 19.59,2.75 20,2.75 C20.41,2.75 20.75,3.09 20.75,3.5 L20.75,7.69000006 L21.4699993,6.96999979 C21.7599993,6.6799998 22.2400007,6.6799998 22.5300007,6.96999979 C22.8200007,7.25999978 22.8200007,7.73999974 22.5300007,8.02999973 L20.5300007,10.0299997 C20.3900007,10.1699997 20.2,10.25 20,10.25 C19.9,10.25 19.8099991,10.2299996 19.7099991,10.1899996 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4694531,10.0299413 L17.4694531,8.02994132 C17.1794531,7.73994133 17.1794531,7.2599414 17.4694531,6.96994141 C17.7594531,6.67994142 18.2394545,6.67994142 18.5294545,6.96994141 L20.5294545,8.96994185 C20.8194545,9.25994185 20.8194545,9.73994133 20.5294545,10.0299413 C20.3794545,10.1799413 20.1894538,10.2499416 19.9994538,10.2499416 C19.8094538,10.2499416 19.6194531,10.1799413 19.4694531,10.0299413 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,0 L24,24 L0,24 L0,0 L24,0 Z",
    id: "Vector",
    opacity: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineCardReceive);
export default __webpack_public_path__ + "static/media/vuesax-outline-card-receive.a7126535edf9634d00a390a3676d24d4.svg";
export { ForwardRef as ReactComponent };